import { useQuery } from "react-query";
import { axios } from "../../lib/axios";
import { onError } from "./onError";

  const labelOf = (o) => (o?.name || o?.display || o?.orgName || String(o?.id ?? ""));
  const normalize = (s) =>
    (s || "").normalize("NFKD").replace(/[\u200B-\u200D\uFEFF]/g, "").replace(/\s+/g, " ").trim().toLowerCase();

  const sortInPlace = (arr) =>
    arr.sort((a, b) =>
      normalize(labelOf(a)).localeCompare(normalize(labelOf(b)), undefined, { numeric: true })
    );

export function useOrgQuery({ onSuccess, orgId = null, ...props }) {
  const { select: upstreamSelect, includeExcluded, ...rest } = props;

  const fetchOrganizations = () => {
    const base = orgId ? `organization/${orgId}` : "organization";
    const qs = includeExcluded ? "?includeExcluded=true" : "";
    return axios.get(`${base}${qs}`);
  };

  const composedSelect = (res) => {
    const base = typeof upstreamSelect === "function" ? upstreamSelect(res) : res?.data;

    if (Array.isArray(base)) return sortInPlace(base);

    if (Array.isArray(base?.data)) {
      return { ...base, data: sortInPlace(base.data) };
    }

    return base;
  };

  const query = useQuery(
    ["organizations", orgId, includeExcluded],
    fetchOrganizations,
    {
      select: composedSelect,
      onSuccess,
      onError,
      ...rest,
    }
  );

  return query;
}